import { getRoleLabel, Role } from './enum/Role';
export interface ProfileGetAttributes {
  client_id: string;
  client_name: string;
  email: string;
  role: Role;
  name: string;
  name_kana: string;
  notification_emails: string[];
}
export class ProfileModel {
  client_id: string;
  client_name: string;
  email: string;
  role: Role;
  role_label: string;
  name: string;
  name_kana: string;
  notification_emails: string[];

  constructor(input?: ProfileGetAttributes) {
    this.client_id = input ? input.client_id : '';
    this.client_name = input ? input.client_name : '';
    this.email = input ? input.email : '';
    this.role = input ? input.role : 'none';
    this.role_label = input ? getRoleLabel(input.role) : '';
    this.name = input ? input.name : '';
    this.name_kana = input ? input.name_kana : '';
    this.notification_emails = input ? input.notification_emails : [];
  }
}
